import { Action } from 'redux'
import { routerReducer } from 'react-router-redux'

import State from '../states'
import comment from './comment'
import eventHub from './eventHub'
import login from './login'
import mediaInput from './mediaInput'
import ui from './ui'
import world from './world'

export default (state: State, action: Action): State => {
  // Notice: we cannot use combinedReducer here as it's deliberately
  // opinionated :/
  // it doesn't like extra key in object, like the navigation we set below
  // https://github.com/reactjs/redux/issues/2427
  // TODO: maybe we should find third party lib which provies better combined
  // reducer function
  const combinedState: State = {
    ...state,
    world: world(state && state.world, action),
    login: login(state && state.login, action),
    eventHub: eventHub(state && state.eventHub, action),
    mediaInput: mediaInput(state && state.mediaInput, action),
    comment: comment(state && state.comment, action),
    ui: ui(state && state.ui, action),
    router: routerReducer(state && state.router, action)
  }
  return combinedState
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts